import React from "react";
import { Form } from "react-bootstrap";

interface TextareaInputProps {
  label: string;
  name: string;
  value: string;
  required?: boolean;
  placeholder?: string;
  onChange: (name: string, value: string) => void;
}

const TextareaInput: React.FC<TextareaInputProps> = ({
  label,
  name,
  value,
  required = false,
  placeholder = "",
  onChange,
}) => {
  return (
    <Form.Group className="mb-3">
      <Form.Label>
        {label} {required && <span className="text-danger">*</span>}
      </Form.Label>
      <Form.Control
        as="textarea"
        rows={3}
        name={name}
        value={value}
        placeholder={placeholder}
        required={required}
        onChange={(e) => onChange(name, e.target.value)}
      />
    </Form.Group>
  );
};

export default TextareaInput;